import LiveCasinoArea from "../GameAreas/LiveCasino";
import SlotsArea from "../GameAreas/Slots";
import EventsArea from "../GameAreas/Events";
import SportsArea from "../GameAreas/Sports";
import LoyaltyArea from "../GameAreas/Loyalty/Loyalty";
import Promotions from "../Layouts/Promotions";
import BallysTournament from "../Layouts/BallysTournament";

const GamesWrapper = ({
  selectedGameAreaType,
  login,
  openPopup,
  gameWrapperArea,
}) => {
  return (
    <div id="game-areas-wrapper" ref={gameWrapperArea}>
      {selectedGameAreaType &&
        (selectedGameAreaType === "liveCasino" ? (
          <LiveCasinoArea login={login} openPopup={openPopup} />
        ) : selectedGameAreaType === "events" ? (
          <EventsArea login={login} openPopup={openPopup} />
        ) : selectedGameAreaType === "loyalty" ? (
          <LoyaltyArea login={login} openPopup={openPopup} />
        ) : selectedGameAreaType === "promotions" ? (
          <Promotions login={login} openPopup={openPopup} />
        ) : (
          <BallysTournament login={login} openPopup={openPopup} />
        ))}
    </div>
  );
};

export default GamesWrapper;
